import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-trackid',
  templateUrl: './trackid.component.html',
  styleUrls: ['./trackid.component.css']
})
export class TrackidComponent implements OnInit {

  trackIdForm: any;
  submitted = false;
  bool_trackComp: boolean = false;
  bool_trackCompEnter: boolean = true;
  public status_list_bool_eri: boolean = false;
  public status_list_bool_pdu: boolean = false;
  public status_list_bool_cri: boolean = false;
  public status_list_bool_dnf: boolean = false;


  public pdu_ticketId: any;
  public pdu_entrydate: any;
  public pdu_state: any;
  public pdu_district: any;
  public pdu_iticode: any;
  public pdu_trade: any;
  public pdu_name: any;
  public pdu_email: any;
  public pdu_mobileno: any;
  public pdu_ccrefno: any;
  public pdu_ccrefnostatus: any;
  public pdu_orderid: any;
  public pdu_date: any;
  public pdu_singlerollno: any;
  public pdu_numberofstud: any;
  public pdu_amount: any;
  public pdu_descreption: any;
  public pdu_admin_status: any;
  public pdu_admin_status_desc: any;
  public styleObject: any;
  public bulkregno: any;

  public erform_ticketId: any;
  public erform_state: any;
  public erform_district: any;
  public erform_iticode: any;
  public erform_trade: any;
  public erform_name: any;
  public erform_email: any;
  public erform_attendance: any;
  public erform_regno: any;
  public erform_status: any;
  public erform_date: any;
  public erform_shift: any;
  public erform_center: any;
  public erform_amount: any;
  public erform_description: any;
  public erform_ntef: any;
  public erform_issuedetail: any;
  public erform_admin_status: any;
  public erform_admin_status_desc: any;


  public criform_ticketId: any;
  public criform_state: any;
  public criform_district: any;
  public criform_iticode: any;
  public criform_trade: any;
  public criform_name: any;
  public criform_email: any;
  public criform_attendance: any;
  public criform_regno: any;
  public criform_status: any;
  public criform_date: any;
  public criform_shift: any;
  public criform_center: any;
  public criform_amount: any;
  public criform_description: any;
  public criform_invigname: any;
  public criform_ntef: any;
  public criform_issuedetail: any;
  public criform_admin_status: any;
  public criform_admin_status_desc: any;

  public dnfticketId: any;
  public dnfentrydate: any;
  public dnfstate: any;
  public dnfname: any;
  public dnfemail: any;
  public dnfmobileno: any;
  public dnfdate: any;
  public dnfnumberofstud: any;
  public dnfamount: any;
  public dnfdescreption: any;
  public dnfadmin_status: any;
  public dnfadmin_status_desc: any;
  public dnfbulkregno: any;
  public dnfpaymethod: any;
  public dnfutr: any;
  public dnfascmob: any;
  public dnfupload: any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router) { }

  ngOnInit(): void {
    this.trackIdForm = this.formBuilder.group({
      ticketId: ['', [Validators.required]],
    });
  }


  get t() {
    return this.trackIdForm.controls;
  }

  onSubmitTrackId() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.trackIdForm.invalid) {
      return;
    }

    //this.api.TrackIdCheck(this.trackIdForm.value).subscribe((result:any)=>{});

    this.api.trackIdPdu(this.trackIdForm.value).subscribe((result: any) => {


      console.log(result);
      if (result.table_name == 'ERIFORM') {


        this.erform_ticketId = result.refno;
        this.erform_state = result.state;
        this.erform_district = result.district;
        this.erform_iticode = result.iticode;
        this.erform_trade = result.trade;
        this.erform_name = result.username;
        this.erform_email = result.email;
        this.erform_attendance = result.attendance;
        this.erform_regno = result.regno;
        this.erform_status = result.status;
        this.erform_date = result.date;
        this.erform_shift = result.shift;
        this.erform_center = result.center;
        this.erform_description = result.description;
        this.erform_ntef = result.ntef;
        this.erform_issuedetail = result.issuedetail;
        this.erform_admin_status = result.admin_status;
        this.pdu_admin_status = result.admin_status;
        this.erform_admin_status_desc = result.admin_status_description;

        this.status_list_bool_eri = true;
        this.status_list_bool_pdu = false;
        this.status_list_bool_cri = false;
        this.status_list_bool_dnf = false;


      }
      else if(result.table_name == 'DNFFORM'){

        this.dnfpaymethod = result.paymethod;
        this.dnfutr = result.utr;
        this.dnfascmob = result.ascmob;
        this.dnfupload = result.upload;
        this.dnfticketId = result.ticketId;
        this.dnfentrydate = result.entrydate;
        this.dnfstate = result.state;
        this.dnfname = result.name;
        this.dnfemail = result.email;
        this.dnfmobileno = result.mobileno;
        this.dnfdate = result.date;
        this.dnfnumberofstud = result.numberofstud;
        this.dnfamount = result.amount;
        this.dnfdescreption = result.descreption;
        this.dnfadmin_status = result.admin_status;
        this.dnfadmin_status_desc = result.admin_status_description;

        this.status_list_bool_dnf = true;
        this.status_list_bool_cri = false;
        this.status_list_bool_eri = false;
        this.status_list_bool_pdu = false;


      }
      else if (result.table_name == 'CRIFORM') {


        this.criform_ticketId = result.refno;
        this.criform_state = result.state;
        this.criform_district = result.district;
        this.criform_iticode = result.iticode;
        this.criform_trade = result.trade;
        this.criform_name = result.username;
        this.criform_email = result.email;
        this.criform_attendance = result.attendance;
        this.criform_regno = result.regno;
        this.criform_status = result.status;
        this.criform_date = result.date;
        this.criform_shift = result.shift;
        this.criform_center = result.center;
        this.criform_description = result.description;
        this.criform_ntef = result.ntef;
        this.criform_invigname = result.invigname;
        this.criform_issuedetail = result.issuedetail;
        this.criform_admin_status = result.admin_status;
        this.pdu_admin_status = result.admin_status;
        this.criform_admin_status_desc = result.admin_status_description;

        this.status_list_bool_cri = true;
        this.status_list_bool_eri = false;
        this.status_list_bool_pdu = false;
        this.status_list_bool_dnf = false;


      }


      else {



        this.pdu_ticketId = result.ticketId;
        this.pdu_entrydate = result.entrydate;
        this.pdu_state = result.state;
        this.pdu_district = result.district;
        this.pdu_iticode = result.iticode;
        this.pdu_trade = result.trade;
        this.pdu_name = result.name;
        this.pdu_email = result.email;
        this.pdu_mobileno = result.mobileno;
        this.pdu_ccrefno = result.ccrefno;
        this.pdu_ccrefnostatus = result.ccrefnostatus;
        this.pdu_orderid = result.orderid;
        this.pdu_date = result.date;
        this.pdu_singlerollno = result.singlerollno;
        this.pdu_numberofstud = result.numberofstud;
        this.pdu_amount = result.amount;
        this.pdu_descreption = result.descreption;
        this.pdu_admin_status = result.admin_status;
        this.pdu_admin_status_desc = result.admin_status_description;

        this.status_list_bool_eri = false;
        this.status_list_bool_pdu = true;
        this.status_list_bool_cri = false;
        this.status_list_bool_dnf = false;

      }









      if (this.pdu_admin_status == 'pending') {
        this.styleObject = {
          // borderBottom: '3px solid lightgreen'
          ['background-color']: 'red',
          ['color']: '#fff'
        };
      }
      else if (this.pdu_admin_status == 'rejected') {
        this.styleObject = {
          // borderBottom: '3px solid lightgreen'
          ['background-color']: '#2955a9',
          ['color']: '#fff'
        };
      }
      else if (this.pdu_admin_status == 'resolved') {
        this.styleObject = {
          // borderBottom: '3px solid lightgreen'
          ['background-color']: 'green',
          ['color']: '#fff'
        };
      }
      else if (this.pdu_admin_status == '') {
        this.pdu_admin_status = 'pending'
        this.styleObject = {
          // borderBottom: '3px solid lightgreen'
          ['background-color']: 'red',
          ['color']: '#fff'
        };
      }




      if (result.status == 'fail') {
        alert("Enter Your Correct TicketId Number")
        return;
      }
      else {
        this.submitted = false;
        this.bool_trackCompEnter = false;
        this.bool_trackComp = true;
      }
    });

    this.api.trackIdPduBulkregno(this.trackIdForm.value).subscribe((result: any) => {
      this.bulkregno = result;
    });


  }

  back_fn() {
    this.bool_trackCompEnter = true;
    this.bool_trackComp = false;
  }

  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
}
